import { PopupStates } from '@/enums/popup-states';
import { IStudyStore } from '@/interfaces/store/study-store/study-store.store.interface';
import { IMutations } from '@/interfaces/store/mutations.interfaces';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { StudentField, IBudget } from '@studyportals/studentdomain';
import { state } from './state';

const mutations: IMutations = {
	setActiveStudyId(studyId: number): void {
		state.activeStudyId = studyId;
	},
	setPopupState(popupState: PopupStates): void {
		state.popupState = popupState;
	},
	setLoggedInState(loggedInState: boolean) {
		state.userLoggedIn = loggedInState;
	},
	setProfileCompleteness(profileCompleteness: number) {
		state.bestFitCompleteness = profileCompleteness;
	},
	setActiveMainDeterminant(determinant: ScoreDeterminantType | null) {
		state.activeMainDeterminant = determinant;
	},
	setActiveSubDeterminant(determinant: ScoreDeterminantType | null) {
		state.activeSubDeterminant = determinant;
	},
	setTuitionBudget(budget?: IBudget) {
		if (budget) {
			state.userData = {
				...state.userData,
				[StudentField.TUITION_BUDGET]: budget,
			};
		}
	},
	setUserNationality(nationality?: number) {
		if (!nationality) return;

		state.userData = {
			...state.userData,
			[StudentField.NATIONALITY_COUNTRY_ID]: nationality,
		};
	},
	setUserCountryOfResidence(countryOfResidence?: number) {
		if (!countryOfResidence) return;

		state.userData = {
			...state.userData,
			[StudentField.RESIDENCE_COUNTRY_ID]: countryOfResidence,
		};
	},
	setCurrency(currency?: string) {
		if (!currency) return;

		state.userData = {
			...state.userData,
			[StudentField.CURRENCY]: currency,
		};
	},
	setLivingBudget(budget?: IBudget) {
		if (budget) {
			state.userData = {
				...state.userData,
				[StudentField.LIVING_BUDGET]: budget,
			};
		}
	},
	setWorkExperience(workExperience?: string) {
		if (workExperience) {
			state.userData = {
				...state.userData,
				[StudentField.WORK_EXPERIENCE]: workExperience,
			};
		}
	},
	setGpa(gpa?: object) {
		if (gpa) {
			state.userData = {
				...state.userData,
				[StudentField.GPA]: gpa,
			};
		}
	},
	setAreDependenciesLoaded(areDependenciesLoaded: boolean): void {
		state.areDependenciesLoaded = areDependenciesLoaded;
	},
	setIsReady(isReady: boolean): void {
		state.isReady = isReady;
	},
	setNewStudyStore(studyId: number, module: IStudyStore): void {
		state.studyStores?.set(studyId, module);
	},
};

export { mutations };
